// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

/*********************************************************************************************
* Refresh the collection page with the provided filters.
	* 
	* @param {string} url_filters - The URL parameters for the filters.
*/
function refreshCollectionPageWithFilters(url_filters) {
    let currentUrl = '//' + location.host + location.pathname;
    let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
    
    // Créer un nouvel élément DIV pour insérer le HTML récupéré
    let newPageEl = document.createElement('DIV');
    newPageEl.innerHTML = newPageString;

    // Mise à jour des articles de la collection avec les nouveaux filtres
    var newSection = newPageEl.querySelector('.mm-grid-card-collection');
    document.querySelector('.mm-grid-card-collection').innerHTML = newSection.innerHTML;

    // Mise à jour des filtres actifs
    var activeFilters = newPageEl.querySelectorAll('.active-filters');
    activeFilters.forEach(function (activeFilter) {
        var newActiveFilters = document.querySelectorAll('.active-filters');
        newActiveFilters.forEach(function (newActiveFilter) {
            newActiveFilter.innerHTML = activeFilter.innerHTML;
        });
    });
    
    // Mise à jour des autres éléments avec la classe 'mm-reload'
    var reloadElems = newPageEl.querySelectorAll('.mm-reload');
    reloadElems.forEach(function (reloadElem, index) {
        var newElems = document.querySelectorAll('.mm-reload');
        newElems[index].innerHTML = reloadElem.innerHTML;
    });

    // Mise à jour de l'URL dans l'historique sans recharger la page
    window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
    document.querySelector('.mm-grid-card-collection').classList.remove('mm-loading');
    
    // Vérifie les changements dans les filtres après le rafraîchissement
    checkForChanges();
    loadSizeValue();
}

/*********************************************************************************************
* Return the Shopify section ID of the collection grid.
	* 
	* @returns {string} - The section ID of the grid.
*/
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-grid-collection');
    const gridSection = gridElem.closest('.shopify-section');
    return gridSection.id;
}

/*********************************************************************************************
* Return the Shopify section ID without the 'shopify-section-' prefix.
	* 
	* @returns {string} - The shortened section ID.
*/
function returnShopifySectionIdShort() {
    return returnShopifySectionId().replace('shopify-section-', '');
}

/*********************************************************************************************
* Perform a synchronous GET request.
	* 
	* @param {string} theUrl - The URL to request.
	* @returns {string} - The response text from the request.
*/
function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false);  // Synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
}

/*********************************************************************************************
* Check for changes in the filter inputs and submit the form if changes are detected.
	*	
*/
function checkForChanges() {

    FORM.addEventListener('submit', function () {
      event.preventDefault();
      mmCloseFilters();
      fakeSubmitForm();
    });
}


/*********************************************************************************************
* Update the sort_by query parameter and reload the page with the new sorting applied.
	* 
	* @param {HTMLSelectElement} select - The select element for sorting.
*/
function mmSortByChanged(select) {
    const hiddenSelect = document.getElementById('mmSortByHiddenElem');
    hiddenSelect.value = select.value;
    fakeSubmitForm();
}

/*********************************************************************************************
* Serialize the form data and refresh the collection page with the filters.
	*
*/
function fakeSubmitForm() {
    let form = document.getElementById("collectionFacetsForm");
    let url_filters = new URLSearchParams(new FormData(form)).toString();
    document.querySelector('.mm-grid-card-collection').classList.add('mm-loading');
    
    // Rafraîchir la collection avec les filtres
    setTimeout(() => {
        refreshCollectionPageWithFilters(url_filters);
    }, "0");
}

/*********************************************************************************************
* Mobile filter drawer functions for screens smaller than 900px.
	*
*/
if (window.innerWidth < 900) {
    
    /*********************************************************************************************
	* Open the mobile filters drawer.
		*
    */
    function mmOpenFiltersMobile() {
        var wrapperMobile = document.querySelector('.mm-grid-second-container-filter');
        wrapperMobile.classList.add('mm-open');
        document.querySelector('html').classList.add('stop-scrolling');  // Empêche le scroll en arrière-plan
    }

    /*********************************************************************************************
	* Close the mobile filters drawer.
		*
	*/
    function mmCloseFiltersMobile() {
        var wrapperMobile = document.querySelector('.mm-grid-second-container-filter');
        wrapperMobile.classList.remove('mm-open');
        document.querySelector('html').classList.remove('stop-scrolling');  // Réactive le scroll
    }

    /*********************************************************************************************
    * Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
		* 
    */
    function mmCheckDrawer() {
        var currentUrl = document.location.href.indexOf('?open_filters');
        if (currentUrl !== -1) {
            mmOpenFiltersMobile();
        }
    }
}

/*********************************************************************************************
* Toggle the accordion state for filters. 
	* Automatically opens the first three by default.
*/
function mmFiltersAccordeons() {
    const filtersHeaders = document.querySelectorAll('.mm-cf-tag-filter-header');

    filtersHeaders.forEach(function(filtersHeader, index) {
        // Activer les trois premiers filtres par défaut
        if (index < 3) {
            filtersHeader.classList.add('mm-active');
        }

        // Ajoute un événement de clic pour ouvrir/fermer les filtres
        filtersHeader.addEventListener('click', function() {
            filtersHeader.classList.toggle('mm-active');
        });
    });
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    checkForChanges();
	mmFiltersAccordeons();
    loadSizeValue();
});


// SIZE FILTER
const FORM = document.getElementById('collectionFacetsForm');

// REPLACE "," by "." in decimal inputs
function replaceComma(input) {
    input.value = input.value.replace(',', '.');
}

function addSizeToFilters(sizeString) {
  console.log('inside function');

  const size = Number(sizeString.replace(',', '.'));
  const inputs = document.querySelectorAll('#mmFiltersSizeElement .mm-cf-filter-size');
  const main_input = document.querySelector('#sizeInput');

  let minSize = Infinity;
  let maxSize = -Infinity;
  let found = false;

  inputs.forEach(function(input) {
    let [min, max] = input.value.replace(/,/g, '.').split('-').map(Number);

    // Mettre à jour les bornes min et max globales
    if (!isNaN(min) && !isNaN(max)) {
      minSize = Math.min(minSize, min);
      maxSize = Math.max(maxSize, max);
    }

    if (size >= min && size <= max) {
      input.checked = true;
      found = true;
    } else {
      input.checked = false;
    }
  });

  // Gérer les messages
  let messageContainer = document.getElementById('filterMessage');
  if (!messageContainer) {
    messageContainer = document.createElement('div');
    messageContainer.id = 'filterMessage';
    messageContainer.style.color = 'red';
    messageContainer.style.fontSize = '12px';
    messageContainer.style.marginTop = '4px';

    const inputContainer = main_input.closest('.mm-cf-tag-filter-list');
    inputContainer.appendChild(messageContainer);
  }

  const message_min = main_input.dataset.messageMin;
  const message_max = main_input.dataset.messageMax;

  if (found) {
    messageContainer.textContent = '';
    messageContainer.style.display = 'none';
  } else if (size < minSize) {
    messageContainer.textContent = `${message_min} ${minSize.toFixed(1)} cm.`;
    messageContainer.style.display = 'block';
  } else if (size > maxSize) {
    messageContainer.textContent = `${message_max} ${maxSize.toFixed(1)} cm.`;
    messageContainer.style.display = 'block';
  } else {
    messageContainer.textContent = '';
    messageContainer.style.display = 'none';
  }

  // Stocker localement
  localStorage.setItem('longueur', size);
  localStorage.setItem('max_size_selector', size);
}


function loadSizeValue() {
  const sizeValue = localStorage.getItem('longueur'); // récupération correcte
  const urlParams = new URLSearchParams(window.location.search);
  const input = document.getElementById('sizeInput');

  // Vérifie que `sizeValue` existe et que l'URL contient le paramètre requis
  if (
    sizeValue &&
    urlParams.has('filter.v.m.custom.debut_et_fin_de_pointure')
  ) {
    input.value = sizeValue;
  }
}


function mmChangeLocalStorageDataForFootSizeCollection(storageName, input) {
  mmChangeLocalStorageData(storageName, input.value);
}

function mmChangeLocalStorageData(key, value) {
  // Vérifie si la clé existe dans le localStorage
  if (localStorage.getItem(key) !== null) {
    // La clé existe, on met à jour sa valeur
    localStorage.setItem(key, value);
  } else {
    // La clé n'existe pas, on la crée avec la valeur donnée
    localStorage.setItem(key, value);
  }
}

function mmOpenFilters() {
  const wrapper = document.querySelector('.mm-filters-wrapper');
  wrapper.classList.add('mm-visible');
}
function mmCloseFilters() {
  const wrapper = document.querySelector('.mm-filters-wrapper');
  wrapper.classList.remove('mm-visible');
}
















